<template>
  <div class="search fixed-nav">
    <MainHeader
      :dark="false"
      :fixedMenu="true"
      :loginButton="true"
      :tiles="false"
      @logoClick="logoClick"
    >
      <svg>
        <use v-if="selectedTranslation === 'en'" xlink:href="#logoWmkSvgEng"></use>
        <use v-else xlink:href="#logoWmkSvg"></use>
      </svg>
    </MainHeader>
    <div class="sections">
      <section class="section-main">
        <div class="container container-small container-expand bg-light2">

          <div class="filters-header">
            <h2 class="text-xl">
              {{ searchData.filter.header }}
            </h2>
            <SelectCustom
              :isSearchable="false"
              :options="categoriesToArray(virtualData.categories)"
              :isSelected="selectedCategoryItems"
              :filterID="'select-category'"
              :translations="searchData.filter"
            />
          </div>

          <label for="content-toggle"
                  :class="{
                    'content-toggle-label': true,
                    'btn-full': true,
                    'content-toggle-label-active': togglerActive
                  }"
                  v-if="filtersDataLoaded">
            <span class="text-m" v-if="!togglerActive">
              {{ searchData.filter.toggleLabel }}
            </span>
            <span class="text-m" v-else>
              {{ searchData.filter.toggleLabelActive }}
            </span>
          </label>
          <input type="checkbox" id="content-toggle" class="content-toggle-input" @change="toggleContent" v-if="filtersDataLoaded" />
          <div :class="{
                  'content-toggle-content': filtersDataLoaded
                }">
            <div class="filters-search content-toggle-hidden content-toggle-visible-md">

              <form action="#"
                    method="post"
                    @submit.prevent="searchProducts()">
                <label class="search-label">
                  <input
                    type="search"
                    :placeholder="searchData.input.placeholder"
                    v-model="searchField">
                  <button
                    type="submit"
                    class="search-label-btn"
                    :title="searchData.input.button"
                    :disabled="searchField.length < 2">
                    <svg height="12" width="12">
                      <use xlink:href="#arrowRight2Svg"></use>
                    </svg>
                    <span>{{ searchData.input.button }}</span>
                  </button>
                </label>
              </form>

            </div>
            <form action="#"
                  method="post"
                  @submit.prevent="searchProducts()"
                  v-if="filtersDataLoaded">
              <div class="content-toggle-hidden">
                <Filters :filters="filtersData" />
              </div>
              <div :class="{
                      'filters-footer': true,
                      'filters-footer-active': togglerActive
                    }">
                <button type="submit"
                        class="btn-full"
                        v-if="togglerActive">
                  <span class="text-m">{{ searchData.filter.button }}</span>
                </button>

                <div class="info text-m">
                  <template v-if="searchProductsData.length && totalSearchItems > 0">
                    <span v-accent="searchProductsTotal(searchData.results.itemsFound, searchProductsData.length)"></span>
                    {{totalSearchItems}}
                  </template>
                  <template v-else>
                    <span v-accent="searchData.results.nothingFound"></span>
                  </template>
                </div>
              </div>
            </form>
            <div v-else class="container container-small text-center content-toggle-hidden">
              <p v-if="filtersDataLoadingError">
                {{ errorData.networkError }}
              </p>
              <p v-else v-accent="productData.single.loading.header"></p>
            </div>
          </div>
        </div>
      </section>
      <ProductGallery
        :items="searchProductsData"
      />
      <MainFooter
        key="footer"
        :content="footerData"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import Filters from '@/components/Filters.vue'
import ProductGallery from '@/components/product/ProductGallery.vue'
import SelectCustom from '@/components/SelectCustom.vue'
import axios from 'axios'

export default {
  name: 'search',
  components: {
    MainHeader,
    MainFooter,
    Filters,
    ProductGallery,
    SelectCustom
  },
  data: function () {
    return {
      filtersData: [],
      filtersDataLoaded: false,
      filtersDataLoadingError: false,
      searchProductsData: [],
      totalSearchItems: 0,
      searchField: '',
      filtersForURL: null,
      selectedCategoryItems: {
        'value': null,
        'label': ''
      },
      togglerActive: false
    }
  },
  methods: {
    ...mapActions([
      'setActiveListItem',
      'setActiveSearch',
      'resetActiveSearch',
      'resetActiveFilters'
    ]),
    getFilters () {
      this.filtersDataLoaded = false
      this.togglerActive = false

      // REQUEST FILTERS FOR CURRENT CATEGORY;
      axios.get(this.apiPath + 'filters/' + this.activeCategoryName)
        .then((response) => {
          this.filtersData = response.data
          this.filtersDataLoaded = true
        })
        .catch((_err) => {
          console.log('Get filters / ' + _err)
          this.filtersData = []
          this.filtersDataLoadingError = true
        })
    },
    searchProducts () {
      let searchParams = ''

      // SELECTED FILTERS REQUEST;
      this.filtersForURL = this.convertFiltersToURL(this.activeFilters)
      searchParams = 'eksponaty/' + this.activeCategoryName

      if (this.filtersForURL) {
        searchParams += '?' + this.filtersForURL
      }
      if (this.searchField.length >= 2 || this.activeSearch) {
        searchParams += (!this.filtersForURL ? '?' : '&') + 'filters[search]=' + encodeURIComponent(this.searchField)
        this.setActiveSearch(this.searchField)
      } else {
        this.resetActiveSearch()
      }

      axios.get(this.apiPath + searchParams)
        .then((response) => {
          if (typeof response.data === 'object') {
            this.searchProductsData = (response.data.items && response.data.items.length ? response.data.items.reverse() : [])
            this.totalSearchItems = (response.data.totalItemsQty ? response.data.totalItemsQty : 0)
          }
        })
        .catch((_err) => {
          console.log('Get search products / ' + _err)

          this.searchProductsData = []
          this.totalSearchItems = 0
          this.resetActiveFilters()
        })
    },
    // CONVERT CATEGORIES OBJECT TO REUSABLE ARRAY;
    categoriesToArray (catsObject) {
      let retArr = []
      Object.keys(catsObject).map((key) => {
        if (catsObject[key].header) {
          retArr.push({
            value: key,
            label: catsObject[key].header
          })
        }
      })
      return retArr
    },
    // DISPLAY SELECTED CATEGORY;
    selectedCategory (catsObject) {
      if (catsObject[this.activeCategoryName].header) {
        this.selectedCategoryItems = {
          value: this.activeCategoryName,
          label: catsObject[this.activeCategoryName].header
        }
      }
    },
    // CONVERT SELECTED FILTER VALUES TO THE URI PARAM;
    convertFiltersToURL (filtersObj) {
      let retArr = []
      Object.keys(filtersObj).map((key) => {
        if (filtersObj[key].length) {
          filtersObj[key].forEach((filter) => {
            if (filter[0]) {
              retArr.push('filters[' + key + '][]=' + encodeURIComponent(filter[0]))
            }
          })
        }
      })
      return retArr.join('&')
    },
    searchProductsTotal (string, amount) {
      return string.replace('{item}', amount)
    },
    logoClick () {
      this.$router.push({ 'name': 'virtual' })
    },
    toggleContent (event) {
      this.togglerActive = !this.togglerActive
    }
  },
  computed: {
    ...mapGetters([
      'activeCategoryName',
      'errorData',
      'footerData',
      'productData',
      'searchData',
      'virtualData',
      'apiPath',
      'selectedTranslation',
      'activeFilters',
      'activeSearch'
    ])
  },
  created () {
    this.selectedCategory(this.virtualData.categories)
  },
  mounted () {
    this.searchField = this.activeSearch
    this.getFilters()
    this.searchProducts()
    this.selectedCategory(this.virtualData.categories)
  },
  watch: {
    apiPath (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.getFilters()
        this.searchProducts()
      }
    },
    virtualData (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.selectedCategory(this.virtualData.categories)
      }
    },
    '$route.query.kategoria' () {
      this.getFilters()
      this.searchProducts()
    }
  }
}
</script>

<style scoped lang="scss">
.filters-header {
  padding: 0 0 $gap-md 0;
  position: relative;

  .text-xl, .v-select {
    display: inline-block;
    margin: 0;
    width: 100%;
  } // END h2, .v-select;

  @include screen('md') {
    align-content: center;
    display: flex;
    flex-flow: row wrap;
    padding: 0 $gap-md;
    text-align: left;
    width: percentage(2/3);

    .text-xl, .v-select {
      width: auto;
    } // END h2, .v-select;

    .v-select {
      flex: 1 1 auto;
    }
    .text-xl {
      padding-right: 0.5em;
    }

    &:after {
      @include after($gap-md, 4px, 0, auto, 40px, 10);
      background-color: $color-text;
      bottom: -4px;
    }
    .dark & {
      &:after {
        background-color: $text-light;
      }
    } // END .dark &;

  } // END @include screen('sm');

} // END .filters-header;

.filters-search {
  position: relative;

  @include screen('md') {
    padding: 0 $gap-md;
    position: absolute;
    right: 0;
    top: (($gap-lg + $gap-xs) * -1);
    width: percentage(1/3);
  }
} // END .filters-search;

.filters-footer {
  padding: $gap-md 0 0;
  text-align: right;
  width: 100%;

  .info {
    font-weight: 700;
  } // END .info;

  &-active {
    padding: $gap-lg 0 0;

    .info {
      margin: $gap-xl 0 0;
    } // END .info;
  } // END .filters-footer-active;

} // END .filters-footer

@include screen('md') {
  .filters-footer {
    padding: ($gap-lg * 2) $gap-md 0 $gap-md;

    &-active {
      padding: $gap-lg $gap-md 0 $gap-md;
    } // END .filters-footer-active;
  }

  .content-toggle-label {
    bottom: ($gap-lg * 2.5);
    left: ($gap-xl + $gap-md);
    position: absolute;
    width: calc(100% - #{(($gap-xl + $gap-md) * 2)});
    z-index: 100;

    &-active {
      bottom: $gap-lg;
      width: calc(#{percentage(1/3)} - #{($gap-md * 4)});
    } // END .content-toggle-label-active;

  } // END .content-toggle-label;
}

</style>
